import React, { useMemo, useLayoutEffect, memo } from 'react';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@material-ui/core/styles';

const CustomThemeProvider = memo(({ children, themeType }) => {
  const isNewV1Theme = themeType === 'v1.1';
  
  const customTheme = useMemo(() => createTheme({
    isNewV1Theme,
  }), [isNewV1Theme]);

  const themeClassName = isNewV1Theme ? 'v1-0' : 'v0-0';

  // Add theme class to body instead of creating wrapper div to prevent detached DOM nodes
  useLayoutEffect(() => {
    document.body.classList.remove('v0-0', 'v1-0');
    document.body.classList.add(themeClassName);
    
    return () => {
      document.body.classList.remove(themeClassName);
    };
  }, [themeClassName]);

  return (
    <MuiThemeProvider theme={customTheme}>
      {children}
    </MuiThemeProvider>
  );
});

export default CustomThemeProvider; 